import validate from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@8.57.1_ioredis@_46f989e9644025bf25b3245ec62751df/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/usr/src/app/clients/fiu-portal/middleware/01.auth.global.ts";
import _02_45apps_45global from "/usr/src/app/clients/fiu-portal/middleware/02.apps.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45apps_45global
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/usr/src/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_magicast@0.3.5_next-auth@4.22.5_next@15.3.3_@babel+core@7.27_2d61feb85e1b8d57d7572e53b18156cc/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}